export function scrollToSection(id, options = {}) {
  if (!id) return false;
  const el = document.getElementById(id);
  if (!el) return false;
  const prefersReduced =
    typeof window !== "undefined" &&
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // Works with momentum scrolling (fixed + transformed container).
  // Use viewport rect to compute the needed window scroll position.
  const headerEl = document.querySelector("[data-fk-header]");
  const headerH = headerEl ? Math.ceil(headerEl.getBoundingClientRect().height) : 0;
  const rect = el.getBoundingClientRect();
  const targetTop = (window.pageYOffset || 0) + rect.top - headerH - 12; // small breathing room

  window.scrollTo({
    top: Math.max(0, targetTop),
    behavior: prefersReduced ? "auto" : "smooth",
  });
  return true;
}

